import React, {useMemo} from "react";
import {useIntl} from "react-intl";
import PageWrapper from "../../../component/home/HomeContentPage";
import * as Page from "../../../component/home/HomeContentPage";
import KoWebchatSettingColor from "../../../assets/images/home/webchat_setting_color_ko.png";
import KoWebchatSettingBtn from "../../../assets/images/home/webchat_setting_btn_ko.png";

const WebchatInfoPage: React.FC = () => {
    const intl = useIntl();

    const gradient = useMemo(() => (
        <div className={"w-full h-full"}
             style={{
                 background: "linear-gradient(180deg, rgba(68, 26, 152, 0.40) 0%, rgba(255, 211, 186, 0.35) 90%)",
                 filter: "blur(150px)"
             }} />
    ), [])

    return (
        <PageWrapper className={"mt-[88px]"}>
            <div className={"order-2 lg:order-1 z-10"}>
                <Page.Heading>
                    {intl.formatMessage({id: "i0032"})}
                </Page.Heading>
                <Page.Description className={"mt-[16px]"}>
                    {intl.formatMessage({id: "i0033"})}
                </Page.Description>
                <Page.CheckList className={"mt-[40px]"}>
                    <Page.CheckListItem>
                        {intl.formatMessage({id: "i0034"})}
                    </Page.CheckListItem>
                    <Page.CheckListItem>
                        {intl.formatMessage({id: "i0035"})}
                    </Page.CheckListItem>
                    <Page.CheckListItem>
                        {intl.formatMessage({id: "i0036"})}
                    </Page.CheckListItem>
                </Page.CheckList>
            </div>
            <div className={"relative w-[581px] aspect-[581/481] order-1 lg:order-2"}>
                <div className={"w-[893px] h-[831px] absolute top-[-333px] right-[-347px] rotate-[93.5deg]"}>
                    {gradient}
                </div>
                <img src={KoWebchatSettingColor} alt="Webchat Color Setting" width={"88%"} height={"81%"}
                     className={"absolute top-0 right-0 shadow-[0px_54px_64px_-22px_rgba(110,102,126,0.38)]"} />
                <img src={KoWebchatSettingBtn} alt="Webchat Button Setting" width={"60.5%"} height={"56%"}
                     className={"absolute bottom-0 left-0 shadow-[0px_54px_64px_-22px_rgba(110,102,126,0.38)]"}/>
            </div>
        </PageWrapper>
    )
}

export default WebchatInfoPage;
